// extracted by mini-css-extract-plugin
export default {"page":"dYm8cdBO","mainWrapper":"_pKEidhi","title":"hLKXtyBN","sectionTitle":"s4SVoiGn","tabsButtonWrapper":"c4EBZ7fY","buttonTab":"BNn3TfLJ","activeTab":"RuUgvYOA","contentWrapper":"yvSWhlGN","purchaseCardWrapper":"A7U6uIuH","cardsWrapper":"xeuXl4Dl","goodCard":"HgRIjGRa","disableCard":"wdy7ssqi","requiredLevelTablet":"a2zjt0Rm","visibleTablet":"SdXcekWI","backToGameButton":"_7TkenN1"};
    if(module.hot) {
      // 1721069999319
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  